import { render, staticRenderFns } from "./quality.vue?vue&type=template&id=072e761a&scoped=true&"
import script from "./quality.vue?vue&type=script&lang=js&"
export * from "./quality.vue?vue&type=script&lang=js&"
import style0 from "./quality.vue?vue&type=style&index=0&id=072e761a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072e761a",
  null
  
)

export default component.exports